module.exports = __webpack_public_path__ + "static/media/净高.cc6c6a75.svg";